import React, { Component } from 'react';
import apiVendas from '../../services/backAxios';
import './styles.css';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Messages } from 'primereact/messages';
import { email } from '../../modulos/validation/email.js';
import { cpfLogin } from '../../modulos/validation/cpf.js';
import { senha } from '../../modulos/validation/senha.js';
import MensagemAbertura from '../../components/mensagem-abertura/index';
import { criptObjectOnLocalStorage, criptoLocalStorage } from './../../modulos/cripotografia/criptoStorage.js';
import { api } from '../../services/contratoApi';
import moment from 'moment';
import logo from '../../assets/GrupoZelo_horizontal.jpg';
import { retornoHashValor } from '../../modulos/cripotografia/hash.js';
import ReCAPTCHA from 'react-google-recaptcha';

export default class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usuario: '',
            senha: '',
            erroForm: '',
            loading: 'loading',
            submit: false,
            recaptcha: false,
            recaptchaError: false
        };
    }

    async handleHoraDoAviso() {
        const dataHoraDoAviso = moment().format('DD/MM/YYYY hh:mm:ss');

        criptoLocalStorage('dataHoraDoAviso', dataHoraDoAviso);
        criptoLocalStorage('avisoExibido', false);
    }

    async handleIdUltimoAviso(token) {
        await api
            .get('/avisos', { headers: { 'x-auth-token': token } })
            .then(res => {
                localStorage.setItem(
                    'IdUltimoAviso',
                    res.data[res.data.length - 1].Id_mess
                );
                criptoLocalStorage('dataUltimoAviso', res.data.pop().Data_Criacao);
            })
            .catch(err => {
                throw new Error(err);
            });
    }

    static displayname = 'Login';

    url = retornoHashValor(process.env.REACT_APP_1);

    mess = '';

    handleSubmit = e => {
        this.setState({
            loading: 'nada',
            submit: true
        });
        e.preventDefault();

        if (email(this.state.usuario).value === false && cpfLogin(this.state.usuario).value === false) {
            this.setState({
                loading: 'loading',
                submit: false
            });
            this.showError('Usuário inválido');

            return false;
        } else if (senha(this.state.senha).value === false) {
            this.setState({
                loading: 'loading',
                submit: false
            });
            this.showError(senha(this.state.senha).mess);

            return false;
        }

        const dataToSend = {
            usuario: this.state.usuario,
            senha: this.state.senha,
            legado: true
        };

        apiVendas.post(`${this.url}/auth/login`, dataToSend)
            .then(response => {
                if (response.data) {
                    const { permissao, token, id_user, email, refresh_token } = response.data;

                    criptoLocalStorage('email', email);
                    criptoLocalStorage('senha', this.state.senha);
                    criptoLocalStorage('perfilPossivel', '0');
                    criptObjectOnLocalStorage('PERM', permissao);
                    localStorage.setItem('token', token);
                    localStorage.setItem('refresh_token', refresh_token);
                    criptObjectOnLocalStorage('IDuser', id_user);
                    setTimeout(() => {
                        this.setState({
                            loading: 'loading',
                            submit: false
                        });
                        this.props.history.push('/');
                        window.location.reload();
                    }, 2000);
                    setTimeout(
                        this.handleHoraDoAviso,
                        this.handleIdUltimoAviso(localStorage.getItem('token')),
                        2500
                    );
                } else {
                    this.setState({
                        loading: 'loading',
                        submit: false
                    });
                    this.showError('Usuário ou senha inválidos');
                }
            })
            .catch(error => {
                this.setState({
                    loading: 'loading',
                    submit: false
                });

                const mensagem = error.response.data?.mensagem ? JSON.parse(error.response.data?.mensagem)?.message : error.response.data?.error;

                if (error.response?.status === 409) {
                    window.location.replace(retornoHashValor(process.env.REACT_APP_13));
                } else if (error.response.status !== 500) {
                    this.showError(mensagem);
                } else {
                    this.showError('Erro de comunicação com o servidor, tente novamente mais tarde');
                }
            });
    };

    handleUsuario = e => {
        this.setState({
            usuario: e.target.value
        });
    };

    handleSenha = e => {
        this.setState({
            senha: e.target.value
        });
    };

    showError = mess => {
        this.messages.show({
            sticky: false,
            severity: 'error',
            detail: mess
        });
    };

    clear = () => {
        this.messages.clear();
    };

    onBlurUsuario = e => {
        if (email(e.target.value).value === false && cpfLogin(e.target.value).value === false) {
            this.showError('Usuário inválido');
        }
    };

    onBlurSenha = e => {
        if (senha(e.target.value).value === false) {
            this.showError(senha(e.target.value).mess);
        }
    };

    render() {
        return (
            <div className="login-content">
                {this.state.mensagem ? <MensagemAbertura /> : ''}
                <center>
                    <div className="login p-col-12 p-md-5 p-lg-4">
                        <form onSubmit={this.handleSubmit}>
                            <img className="logo-responsivo" src={logo} />
                            <div className="p-float-label p-col-10">
                                <InputText
                                    id="email"
                                    value={this.state.value}
                                    onBlur={this.onBlurUsuario}
                                    onChange={this.handleUsuario}
                                    name="email_login"
                                    placeholder="Seu E-mail ou CPF"
                                />
                            </div>
                            <div className="p-float-label p-col-10">
                                <Password
                                    id="senha"
                                    value={this.state.value}
                                    onBlur={this.onBlurSenha}
                                    onChange={this.handleSenha}
                                    name="nome_login"
                                    placeholder="Sua senha"
                                />
                            </div>
                            <div className=" p-col-10">
                                <Messages ref={el => (this.messages = el)}></Messages>
                            </div>
                            <div style={{
                                transform: 'scale(0.90)',
                                transformOrigin: '0 0'
                            }}>
                                <ReCAPTCHA

                                    sitekey={retornoHashValor(process.env.REACT_APP_11)}
                                    onChange={captchaEvent => {
                                        this.setState({ recaptcha: captchaEvent });
                                    }}
                                />
                            </div>
                            <br />
                            <div className="entrar">
                                <Button
                                    label="Entrar"
                                    type="submit"
                                    disabled={this.state.submit || !this.state.recaptcha}
                                />
                            </div>

                            <div className={this.state.loading}>
                                <ProgressSpinner
                                    style={{
                                        width: '50px',
                                        height: '50px'
                                    }}
                                    strokeWidth="8"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                />
                            </div>
                            <div className="link">
                                <a href="#/acesso">Primeiro Acesso</a>
                                <br />
                                <a href="#/recuperar-senha">Esqueci minha senha</a>
                            </div>
                        </form>

                    </div>
                </center>
            </div>
        );
    }
}
